import { get } from 'services/api';
import { API_V4_BASE_URL } from 'settings';
import { IShelf, IShowcaseCourse } from '../interface/showcase';
import { IUpsell } from 'interface/upsell';
import { ISchool } from 'interface/school';
import { ILesson } from 'interface/lesson';
interface IFilters {
  total_pages: number;
  search: string;
  page: number;
  size: number;
  categoryId: number;
  shelveId: number;
}
interface ISearchResponse<T = any> {
  data: T;
  filters: TFilters;
}

type TParams = Partial<Omit<IFilters, 'total_pages'>>;

export type TFilters = Partial<Omit<IFilters, 'categoryId'>>;

class Showcase {
  public getShowcase(): Promise<IShelf[]> {
    return get({
      url: '/learner/showcase',
      baseURL: API_V4_BASE_URL,
    }).then((response) => response.data.data);
  }

  public getShowcaseOffers<T = IUpsell[]>(size: number = 6): Promise<T> {
    return get({
      url: '/learner/showcase/offers',
      baseURL: API_V4_BASE_URL,
      params: {
        size,
      },
    }).then((response) => response.data.data);
  }

  public getShowcaseLessons<T = ILesson[]>(showcaseId: number): Promise<T> {
    return get({
      url: `/learner/modules/${showcaseId}/lessons`,
      baseURL: API_V4_BASE_URL,
    }).then((response) => response.data.data);
  }

  public getCourses<T = IShowcaseCourse[]>(params: TParams): Promise<ISearchResponse<T>> {
    return get({
      url: '/learner/course/search',
      params: {
        page: 1,
        size: 20,
        ...params,
      },
      baseURL: API_V4_BASE_URL,
    }).then((response) => {
      const filters = {
        page: response.data.page.page,
        search: response.data.page.search,
        total_pages: response.data.total_pages,
      };
      return {
        filters,
        data: response.data.data,
      };
    });
  }

  public getShowcaseSchoolLegacy<T = ISchool[]>(): Promise<T> {
    return get({
      url: '/learner/showcase/schools',
    }).then((response) => response.data.data);
  }

  public getShowcaseSchool<T = ISchool[]>(): Promise<T> {
    return get({
      url: '/learner/showcase/schools',
      baseURL: API_V4_BASE_URL,
    }).then((response) => response.data);
  }

  public getShowcaseKeepWatching<T = IShowcaseCourse[]>(): Promise<T> {
    return get({
      url: '/learner/keep-watching',
      baseURL: API_V4_BASE_URL,
    }).then((response) => response.data.data);
  }
}

export default new Showcase();
